module.exports = __webpack_public_path__ + "static/images/styles/images/leaderboards/battle_mode_8.75b61ac9.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/leaderboards/battle_mode_8.png
// module id = 3656
// module chunks = 11